import { render } from "./Pag.vue?vue&type=template&id=79544814"
import script from "./Pag.vue?vue&type=script&lang=js"
export * from "./Pag.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\germa\\dev\\dcpower.client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__